<template>
  <v-card style="position: relative; z-index: 1200;" class="pa-1">
    <v-toolbar color="blue darken-3" cards dark flat>
      <v-btn icon>
        <v-icon>mdi-clipboard-edit-outline</v-icon>
      </v-btn>
      <v-card-title class="text-h6 font-weight-regular">
        Upload Business Idea
      </v-card-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid>
      <v-form ref="form" v-model="form" v-on:submit.prevent="handleUpload" class="pa-4 pt-6">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field v-model="firstName" :rules="[rules.required]" color="purple darken-2"
              label="First name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field v-model="lastName" :rules="[rules.required]" color="blue darken-2"
              label="Last name"></v-text-field>
          </v-col>
        </v-row>
        <v-text-field v-model="phone" color="deep-purple" label="Phone number(optional)"></v-text-field>
        <v-text-field v-model="email" :rules="[rules.email]" filled color="deep-purple" label="Email address"
          type="email"></v-text-field>
        <v-textarea v-model="idea" auto-grow filled color="deep-purple"
          label="Give us a brief description of the idea, and what problem the idea will solve." rows="4"></v-textarea>
        <v-text-field label="Business Name (required)" prepend-inner-icon="mdi-card-account-details-outline" v-model="title" :rules="[rules.required]"
          filled dense></v-text-field>
        <v-text-field label="Website link (required)" prepend-inner-icon="mdi-web" v-model="link"
          :rules="[rules.required]" filled dense></v-text-field>
        <v-file-input :rules="rules.size" accept="image/png, image/jpeg, image/bmp"
          label="Upload the Business Idea logo" v-model="uploadedLogo" prepend-icon="" prepend-inner-icon="mdi-camera-outline"
          small-chips></v-file-input>
        <v-file-input prepend-icon="" prepend-inner-icon="mdi-briefcase-upload-outline" small-chips label="Upload the Business Idea. Accept images, pdf, etc"
          v-model="uploadedFile"></v-file-input>
        <v-checkbox v-model="agreement" :rules="[rules.required]" color="deep-purple">
          <template v-slot:label>
            I agree to the&nbsp;
            <a href="#" @click.stop.prevent="dialog = true">Terms of Service</a>
            &nbsp;and&nbsp;
            <a href="#" @click.stop.prevent="dialog = true">Privacy Policy</a>*
          </template>
        </v-checkbox>

        <!-- Move submit button inside the form -->
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="$refs.form.reset()">
            Clear
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!form" :loading="isLoading" type="submit" class="white--text" color="deep-purple accent-4"
            depressed>
            Submit
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-container>

    <v-dialog v-model="dialog" absolute max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-3">
          Legal
        </v-card-title>
        <v-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
          Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="agreement = false, dialog = false">
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="white--text" color="deep-purple accent-4" @click="agreement = true, dialog = false">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import axios from 'axios';
import { apiUrl } from '../config';
// import toastMixin from '@/mixins/notifications';

export default {
  data: () => ({
    agreement: false,
    API_URL: apiUrl,
    dialog: false,
    form: false,
    isLoading: false,
    email: "",
    phone: "",
    title: "",
    link: "",
    firstName: "",
    lastName: "",
    uploadedLogo: null,
    uploadedFile: null,
    idea: 'Give us brief description of the idea and what problem it will solve.',
    rules: {
      value: value => !value || value.size < 1000000 || 'Avatar size should be less than 2 MB!',
      email: v => !!(v || '').match(/@/) || 'Please enter a valid email',
      length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
      required: v => !!v || 'This field is required',
    },
  }),
  methods: {
    async createBusinessIdea(formData) {
      try {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken);

        const response = await axios.post(`${this.API_URL}business-ideas/`, formData, {
          headers: {
            'Authorization': authToken,
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('API Response:', response);

        // Check if the status code is 201 (Created)
        if (response.status === 201) {
          return true; // Success
        } else {
          console.error('Unexpected status code:', response.status);
          return false; // Not successful
        }
      } catch (error) {
        console.error('Error creating business idea:', error);
        return false; // Failure
      }
    },

    //handle upload method
    async handleUpload() {
      // if (this.uploadLocation && this.uploadedText || this.uploadedLink || uploadedFiles) {
      // }

      this.isLoading = true
      const businessIdeaData = {
        title: this.title,
        link: this.link,
        firstName: this.firstName,
        lastName: this.lastName,
        idea: this.idea,
        file: this.uploadedFile,
        logo: this.uploadedLogo,
        email: this.email,
        phone: this.phone,
      };

      console.log('business idea data from ideaform.vue', businessIdeaData);

      const formData = new FormData();
      formData.append('first_name', this.firstName);
      formData.append('last_name', this.lastName);
      formData.append('description', this.idea);
      formData.append('company_logo', this.uploadedLogo);
      formData.append('files', this.uploadedFile);
      formData.append('email', this.email);
      formData.append('phone_number', this.phone);
      formData.append('title', this.title);
      formData.append('website_link', this.link);
      formData.append('is_agreed', this.agreement);

      
      const isSuccess = await this.createBusinessIdea(formData);
      this.$emit('handle-toggle-form');
      // Emit events only if the API call is successful (status code 201)
      if (isSuccess) {
        this.$emit('fetch-business-ideas');
      }
      this.isLoading = false
    },

  },
}
</script>